let captureException: ((error: unknown) => void) | null = null
let withScope: ((callback: () => void) => void) | null = null

if (process.env.NODE_ENV === "production") {
  const sentry = require("@sentry/react")
  captureException = sentry.captureException
  withScope = sentry.withScope
}

export function log(error: unknown): void {
  if (captureException && withScope) {
    const capture = captureException
    withScope(() => {
      capture(error)
    })
  }
  console.log(error)
}
